// Whether the browser can actually deliver a push notification right now — used to decide
// whether to fall back to status polling instead of waiting for FCM's onMessage callback.
export const areNotificationsGranted = () =>
  typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted";
